export default __webpack_public_path__ + "static/daysmart-b321ad908910b6e0fe84cbfbdce3c255.png";